const GET_USER_BY_EMAIL = `
  query GetUserByEmail($email: String!) {
    users (where: { email: { _eq: $email } }) {
      id
      email
      firstName: first_name
      lastName: last_name
      phone: phone_number
      persona: current_persona {
        company_id
      }
    }
  }
`

export default GET_USER_BY_EMAIL
